// test1473
(1473 && 0);
